import { validationPopup, hideValidationPopup } from "../redux/actions";
import {
  updateProfile,
  updateProfileFields,
  splitSubRoleForPocketBase,
} from "../auth/authApi";
import { validateProfileForm } from "../auth/validation";

const normalizeSubRole = (selected, previous) => {
  if (!selected) return previous || undefined;
  const val = typeof selected === "string" ? selected.trim() : selected;
  return val || previous || undefined;
};

export const profileSubmit = async (
  dispatch,
  formData,
  lang = "en",
  visibleInputs,
  previosData
) => {
  const data = { ...formData };
  const errors = validateProfileForm(data, lang, visibleInputs);

  if (Object.keys(errors).length > 0) {
    const errorMessage =
      Object.keys(errors).length > 1
        ? lang === "en"
          ? "Please complete all necessary fields."
          : "必須項目を入力してください。"
        : Object.values(errors)[0];

    dispatch(
      validationPopup({
        message: errorMessage,
        icon: "horror",
        type: "error",
      })
    );
    return errors;
  }

  dispatch(
    validationPopup({
      message: "Loading...",
      icon: "loading",
      type: "info",
    })
  );

  const extractPbError = (err) => {
    const fieldErrors = err?.data?.data;
    if (fieldErrors && typeof fieldErrors === "object") {
      const firstKey = Object.keys(fieldErrors)[0];
      if (firstKey) {
        const fe = fieldErrors[firstKey];
        const msg = fe?.message || fe?.code || "Validation error";
        return `${firstKey}: ${msg}`;
      }
    }
    return (
      err?.message ||
      (err?.data && err?.data?.message) ||
      (err?.response && err?.response?.data?.message) ||
      (lang === "en"
        ? "Failed to update profile fields."
        : "プロフィールの更新に失敗しました。")
    );
  };

  try {
    const subCombined = normalizeSubRole(data.subRole, previosData?.subRole);
    const roleFields = splitSubRoleForPocketBase(subCombined);

    const pbData = {
      username: data.username,
      fullName: data.fullName,
      nationality: data.nationality,
      intro: data.intro,
      personalSite: data.personalSite,
      personalBlog: data.personalBlog,
      ...roleFields,
      experience: data.experience,
      mediaLinks: [
        { type: "facebook", link: data.facebook },
        { type: "instagram", link: data.instagram },
        { type: "linkedin", link: data.linkedin },
        { type: "dribbble", link: data.dribbble },
        { type: "behance", link: data.behance },
        { type: "threads", link: data.threads },
        { type: "youtube", link: data.youtube },
        { type: "figma", link: data.figma },
        { type: "tiktok", link: data.tiktok },
        { type: "x", link: data.x },
      ].filter((l) => l.link),
    };

    try {
      await updateProfileFields(pbData);
    } catch (pbErrFields) {
      console.warn("PocketBase field update failed", pbErrFields);
      const msg = extractPbError(pbErrFields);
      dispatch(
        validationPopup({ message: msg, icon: "horror", type: "error" })
      );
      return { fields: msg };
    }

    let avatarFailed = false;
    let avatarErrorMsg = "";
    if (data.profile_img && data.profile_img !== previosData.profile_img) {
      try {
        await updateProfile({ profile_img: data.profile_img });
      } catch (pbErrAvatar) {
        console.warn("PocketBase avatar update failed", pbErrAvatar);
        avatarFailed = true;
        avatarErrorMsg =
          pbErrAvatar?.message ||
          (pbErrAvatar?.data && pbErrAvatar?.data?.message) ||
          (pbErrAvatar?.response && pbErrAvatar?.response?.data?.message) ||
          (lang === "en"
            ? "Failed to update profile image."
            : "プロフィール画像の更新に失敗しました。");
      }
    }

    dispatch(hideValidationPopup());
    if (avatarFailed) {
      dispatch(
        validationPopup({
          message:
            lang === "en"
              ? `Profile updated, but image failed: ${avatarErrorMsg}`
              : `プロフィールは更新されましたが、画像の更新に失敗しました: ${avatarErrorMsg}`,
          icon: "warning",
          type: "warning",
        })
      );
    } else {
      dispatch(
        validationPopup({
          message:
            lang === "en" ? "Profile updated successfully" : "プロフィールが更新されました。",
          icon: "ok",
          type: "success",
        })
      );
    }
    return {};
  } catch (error) {
    console.error("Error during submission:", error);
    dispatch(
      validationPopup({
        message:
          lang === "en"
            ? "An unexpected error occurred."
            : "予期しないエラーが発生しました。",
        icon: "horror",
        type: "error",
      })
    );
  }
};
